import { useState } from "react";

export default function useUploadProgress() {
  const [uploadProgress, setUploadProgress] = useState({
    total: 0,
    completed: 0,
    currentLoaded: 0,
    currentTotal: 0,
    currentRecordIndex: undefined,
    totalRecords: 0,
    phase: undefined,
  });

  const onProgress = (evt) => {
    if (!evt || typeof evt !== "object") return;
    if (evt.type === "image_start") {
      setUploadProgress((prev) => ({
        ...prev,
        currentLoaded: 0,
        currentTotal: 0,
      }));
    } else if (evt.type === "image_progress") {
      setUploadProgress((prev) => ({
        ...prev,
        currentLoaded:
          typeof evt.loaded === "number" ? evt.loaded : prev.currentLoaded,
        currentTotal:
          typeof evt.total === "number" ? evt.total : prev.currentTotal,
      }));
    } else if (evt.type === "image_complete") {
      setUploadProgress((prev) => ({
        ...prev,
        completed: prev.completed + 1,
        currentLoaded: 0,
        currentTotal: 0,
      }));
    } else if (evt.type === "record_change") {
      setUploadProgress((prev) => ({
        ...prev,
        currentRecordIndex:
          typeof evt.index === "number" ? evt.index : prev.currentRecordIndex,
        totalRecords:
          typeof evt.total === "number" ? evt.total : prev.totalRecords,
        phase: evt.phase || prev.phase,
      }));
    }
  };

  const addTotalToProgress = (total) => {
    setUploadProgress((prev) => ({ ...prev, total: prev.total + total }));
  };

  const resetUploadProgress = () => {
    setUploadProgress({
      total: 0,
      completed: 0,
      currentLoaded: 0,
      currentTotal: 0,
      currentRecordIndex: undefined,
      totalRecords: 0,
      phase: undefined,
    });
  };

  return {
    uploadProgress,
    onProgress,
    addTotalToProgress,
    resetUploadProgress,
  };
}
